import { TokenABI } from "@abi/TokenABI";
import type { Address } from "viem";
import { useReadContract } from "wagmi";
import useContract from "./useContract";

const useAllowance = (account: string, spender) => {
	const { tokenContract } = useContract();
	const { data } = useReadContract({
		abi: TokenABI,
		address: tokenContract.address as Address,
		args: [account, spender],
		functionName: "allowance",
	}) ?? { data: "1" };

	const allowance = data;
	//returning 1 to avoid component load on page load (while it's fetching allowance) (allowance itself returns 0 in case)
	return allowance?.toString() ?? "1";
};

export default useAllowance;
